import { useEffect } from 'react';

export default function BookingCalendar() {
  useEffect(() => {
    // Check if script already exists
    const existingScript = document.querySelector('script[src="https://link.msgsndr.com/js/form_embed.js"]');
    
    if (!existingScript) {
      const script = document.createElement('script');
      script.src = 'https://link.msgsndr.com/js/form_embed.js';
      script.type = 'text/javascript';
      script.async = true;
      document.body.appendChild(script);
    }

    return () => {
      // Cleanup if needed
      const script = document.querySelector('script[src="https://link.msgsndr.com/js/form_embed.js"]');
      if (script && script.parentNode) {
        script.parentNode.removeChild(script);
      }
    };
  }, []);

  return (
    <section id="booking" className="relative py-24 bg-black overflow-hidden">
      {/* Background Effects */}
      <div className="absolute inset-0 opacity-30">
        <div className="absolute inset-0" style={{
          backgroundImage: 'linear-gradient(rgba(0, 212, 255, 0.05) 1px, transparent 1px), linear-gradient(90deg, rgba(0, 212, 255, 0.05) 1px, transparent 1px)',
          backgroundSize: '50px 50px'
        }} />
      </div>

      {/* Glowing Orbs */}
      <div className="absolute top-0 left-1/4 w-96 h-96 bg-cyan-500/10 rounded-full blur-3xl" />
      <div className="absolute bottom-0 right-1/4 w-96 h-96 bg-blue-600/10 rounded-full blur-3xl" />

      <div className="container mx-auto px-6 relative z-10">
        <div className="max-w-5xl mx-auto">
          {/* Section Header */}
          <div className="text-center mb-12 scroll-reveal">
            <div className="inline-flex items-center gap-2 px-4 py-2 rounded-full bg-white/5 border border-cyan-400/30 backdrop-blur-sm mb-6">
              <div className="w-2 h-2 bg-cyan-400 rounded-full animate-pulse" />
              <span className="text-xs font-bold text-cyan-400 tracking-wider uppercase">Book Your Demo</span>
            </div>

            <h2 className="text-4xl md:text-5xl lg:text-6xl font-bold mb-6">
              <span className="text-white drop-shadow-[0_0_30px_rgba(0,212,255,0.3)]">Schedule Your </span>
              <span className="text-transparent bg-clip-text bg-gradient-to-r from-cyan-400 to-blue-600 drop-shadow-[0_0_40px_rgba(0,212,255,0.5)]">Free Demo</span>
            </h2>

            <p className="text-lg md:text-xl text-gray-400 max-w-2xl mx-auto">
              See how Bayfront Intelligence can transform your business with AI automation. Pick a time that works for you.
            </p>
          </div>

          {/* Calendar Container */}
          <div className="scroll-reveal">
            <div className="relative bg-white/5 backdrop-blur-xl border border-cyan-400/30 rounded-3xl p-8 md:p-12 shadow-[0_0_60px_rgba(0,212,255,0.2)] overflow-hidden">
              {/* Corner Accents */}
              <div className="absolute top-0 left-0 w-32 h-32 bg-gradient-to-br from-cyan-400/20 to-transparent rounded-br-full" />
              <div className="absolute bottom-0 right-0 w-32 h-32 bg-gradient-to-tl from-blue-600/20 to-transparent rounded-tl-full" />

              {/* GHL Calendar Embed */}
              <div className="relative z-10">
                <iframe 
                  src="https://api.leadconnectorhq.com/widget/booking/DrpuwIlnSGmTpo1SCFaa" 
                  style={{ width: '100%', border: 'none', overflow: 'hidden', minHeight: '600px' }} 
                  scrolling="no" 
                  id="DrpuwIlnSGmTpo1SCFaa_1773209496349"
                  title="Book a Demo Calendar"
                />
              </div>
            </div>

            {/* Trust Indicators Below Calendar */}
            <div className="flex flex-wrap items-center justify-center gap-6 mt-8 text-sm text-gray-400">
              <div className="flex items-center gap-2">
                <i className="ri-shield-check-line text-green-400 text-lg" />
                <span>No commitment required</span>
              </div>
              <div className="w-1 h-1 bg-gray-600 rounded-full" />
              <div className="flex items-center gap-2">
                <i className="ri-time-line text-cyan-400 text-lg" />
                <span>30-minute consultation</span>
              </div>
              <div className="w-1 h-1 bg-gray-600 rounded-full" />
              <div className="flex items-center gap-2">
                <i className="ri-customer-service-2-line text-blue-400 text-lg" />
                <span>Expert guidance included</span>
              </div>
            </div>
          </div>
        </div>
      </div>
    </section>
  );
}